import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import MyFundReportsFunctional from './index.function';
import ViewReverse from '../../components/ViewReverse';
import { formatNumbers } from '../../utils/utils';
import SarSymbol from '../../components/SarSymbol';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import LoaderModal from '../../components/LoaderModal';
import TermsModal from '../../components/TermsModal';
import { SubscribeCard } from '../Subscribe/components';

const MyFundReports = () => {
  const {
    fund_detail,
    TextWeight,
    getContentKey,
    navigate,
    direction,
    isArabic,
    fund_loading,
    showModal,
    selectedDocument,
    setShowModal,
    setSelectedDocument,
    handleDownloadFile,
  } = MyFundReportsFunctional();

  const documents_array = fund_detail?.documents?.filter(
    (val) => val?.documentTypeId !== 5
  );
  return (
    <div className='min-h-full'>
      <ViewReverse className={'gap-5 items-center'}>
        <Text
          text={getContentKey('heading')}
          color='text-black'
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>
      <div className='border border-grey rounded-xl mt-8 py-5 px-5 shadow-light'>
        <div className='mt-2'>
          <div dir={direction} className='my-4'>
            <SubscribeCard item={fund_detail} isSubscribe={false} />
          </div>
          <div dir={direction} className='w-full'>
            <div className='rounded-xl border border-lavender bg-white p-2.5 w-full sm:p-3 lg:w-2/3'>
              <div dir={direction} className='grid grid-cols-2 gap-y-3 w-full'>
                <ViewReverse className={'flex-col items-start'}>
                  <Text
                    text={formatNumbers(fund_detail?.holdings?.total_units, 0)}
                    size={fontSizes.h14}
                    className={'flex-1'}
                    color='text-primary'
                    weight={TextWeight.semiBold}
                  />
                  <Text
                    text={getContentKey('number_of_units_owned')}
                    size={fontSizes.h12}
                    className={'flex-1'}
                    weight={TextWeight.semiBold}
                    color={'text-silver'}
                  />
                </ViewReverse>
                <ViewReverse className={'flex-col items-end'}>
                  <ViewReverse>
                    <SarSymbol color={'text-primary'} />
                    <Text
                      text={formatNumbers(fund_detail?.holdings?.cost_of_units_owned)}
                      size={fontSizes.h14}
                      weight={TextWeight.semiBold}
                      color='text-primary'
                    />
                  </ViewReverse>
                  <Text
                    text={getContentKey('cost_of_units_owned')}
                    size={fontSizes.h12}
                    className={'flex-1'}
                    weight={TextWeight.semiBold}
                    color={'text-silver'}
                  />
                </ViewReverse>
                <ViewReverse className={'flex-col items-start'}>
                  <ViewReverse>
                    <SarSymbol color={'text-primary'} />
                    <Text
                      text={formatNumbers(fund_detail?.holdings?.current_nav)}
                      size={fontSizes.h14}
                      weight={TextWeight.semiBold}
                      color='text-primary'
                    />
                  </ViewReverse>
                  <Text
                    text={getContentKey('current_nav')}
                    size={fontSizes.h12}
                    className={'flex-1'}
                    weight={TextWeight.semiBold}
                    color={'text-silver'}
                  />
                </ViewReverse>
              </div>
            </div>
          </div>


          <div
            dir={direction}
            className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3'
          >
            {
              documents_array?.map((item, index) => {
                return (
                  <ViewReverse className='mt-4 gap-10 flex-col rounded-xl border border-lavender bg-white p-2.5'>
                    <Text
                      text={item?.documentTypeName}
                      color='text-black'
                      size={fontSizes.h14}
                      weight={TextWeight.semiBold}
                    />
                    <div className={'gap-3 flex flex-wrap'}>
                      <div
                        onClick={() => {
                          setShowModal(true)
                          setSelectedDocument(item?.documentFileUrl)
                        }}
                        className='flex flex-1 justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'>
                        <ReactSVG src={icons?.view_icon} />
                        <Text
                          text={getContentKey('view')}
                          color='text-primary'
                          isTruncate={false}
                        />
                      </div>

                      <div className='flex flex-1 justify-center cursor-pointer items-center gap-3 border border-primary rounded-lg py-2 px-5'
                        onClick={() => handleDownloadFile(item?.documentFileUrl)}>
                        <ReactSVG src={icons?.download_icon} />
                        <Text
                          text={getContentKey('download')}
                          color='text-primary'
                          isTruncate={false}
                        />
                      </div>
                    </div>
                  </ViewReverse>
                )
              })
            }

          </div>

          <div dir={direction}>
            {
              fund_detail?.fundReports?.map((item, index) => {
                return (
                  <div
                    className={
                      'mt-3 flex rounded-xl border border-lavender bg-white p-2.5 sm:p-3 w-2/3 justify-between items-start cursor-pointer'
                    }
                    onClick={() => {
                      navigate('/funds/my-funds/view-fund-report', { state: item });
                    }}
                  >
                    <Text
                      text={item?.fundReportTypeName}
                      size={fontSizes.h12}
                      color='text-black'
                      weight={TextWeight.medium}
                    />
                    <ReactSVG src={icons.backVerySm_icon} className={isArabic ? 'rotate-180' : ''} />
                  </div>

                )
              })
            }
          </div>

        </div>
      </div>

      <TermsModal isOpen={showModal} onClose={() => setShowModal(false)} url={selectedDocument} />

      <LoaderModal open={fund_loading} />
    </div>
  );
};

export default MyFundReports;
